// Register the benign-ResizeObserver-error suppressor first so its window
// `error` listener is installed before anything can start firing them.
import "./utils/suppressResizeObserverError";
// Fail loudly on bad build configuration (feature flags, gasless relayer)
// before any app module reads it at import time. See src/config/assertOnBoot.ts.
import "./config/assertOnBoot";
// import { HttpClient as HttpClientIntegration } from "@sentry/integrations";
import * as Sentry from "@sentry/react";
import { BrowserTracing } from "@sentry/tracing";
import buffer from "buffer";
import React from "react";
import ReactDOM from "react-dom/client";
import {
  createRoutesFromChildren,
  matchRoutes,
  useLocation,
} from "react-router-dom";
import App from "./App";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";
import "./i18n/config";
import { GlobalStyle } from "./style";
import { ModalPortal } from "./portal";
// The prop-forwarding filter moved to its own module so TESTS render under the
// same styled-components configuration as the app. See StyledConfigProvider.
import { StyledConfigProvider } from "./styles/StyledConfigProvider";

window.Buffer = window.Buffer || buffer.Buffer;

if (
  process.env.REACT_APP_VERCEL_GIT_COMMIT_REF === "production" ||
  process.env.REACT_APP_VERCEL_GIT_COMMIT_REF === "staging"
) {
  Sentry.init({
    dsn: process.env.REACT_APP_SENTRY_DSN,
    environment: process.env.REACT_APP_VERCEL_GIT_COMMIT_REF,

    // The release tag will be the commit sha that is set by vercel automatically
    release: process.env.REACT_APP_VERCEL_GIT_COMMIT_SHA,

    tracesSampleRate: 1.0,
    // This sets the sample rate to be 10%. You may want this to be 100% while
    // in development and sample at a lower rate in production
    replaysSessionSampleRate: 0.1,
    // If the entire session is not sampled, use the below sample rate to sample
    // sessions when an error occurs.
    replaysOnErrorSampleRate: 1.0,

    // integrations: [
    //   new Sentry.Replay(),
    //   new BrowserTracing({
    //     routingInstrumentation: Sentry.reactRouterV6Instrumentation(
    //       React.useEffect,
    //       useLocation,
    //       useNavigationType,
    //       createRoutesFromChildren,
    //       matchRoutes
    //     ),
    //   }),
    //   new HttpClientIntegration({
    //     // This array can contain tuples of `[begin, end]` (both inclusive),
    //     // single status codes, or a combination of both.
    //     // default: [[500, 599]]
    //     failedRequestStatusCodes: [502, 500],

    //     // This array can contain Regexes, strings, or a combination of both.
    //     // default: [/.*/]
    //     failedRequestTargets: [/.*\.marginx.trade$/],
    //   }),
    // ],
  });
}

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

// App-level boundary (H3). RealtimeErrorBoundary rethrows every error that is
// not a RealtimeError, so those land here and are reported to Sentry. No
// fallback is rendered on purpose: the page looks exactly as it did before
// this boundary existed (no new UI without DESIGN.md sign-off), but the crash
// is no longer invisible.
root.render(
  <React.StrictMode>
    <Sentry.ErrorBoundary>
      <StyledConfigProvider>
        <GlobalStyle />
        <App />
        <ModalPortal />
      </StyledConfigProvider>
    </Sentry.ErrorBoundary>
  </React.StrictMode>
);

serviceWorkerRegistration.unregister();
